import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ActivitiesSection from './ActivitiesSection';
import { TextCell } from '../../components/cell/shared/Cells';
import Pagination from '../../components/pagination/Pagination';
import {
    LRS_VERBS,
    LRS_RESULT_EXTENSIONS,
    LRS_CONTEXT_EXTENSIONS,
    LRS_EVENTS_XAPI_IDS,
} from '../../constants/shared/LrsConstants';
import { lrsEventOnAction } from '../lrs/shared/lrsTrackEvent';
import { getLRSObjectForLocation } from '../lrs/shared/lrsHelpers';
import { ACTIVITIES_TITLE } from '../../constants/reading/DemoModeConstants';

const { INSTRUCTIONAL_ACTIVITY_ID } = LRS_RESULT_EXTENSIONS;
const { DOWNLOAD_LOCATION, FROM_ROUTE_NAME, ETERNAL_STUDENT_ID, GROUP_ID } = LRS_CONTEXT_EXTENSIONS;

const ActivitiesWithPagination = ({
    activities,
    staffId,
    lrsTrackingInfo,
    children,
    studentId,
    selectPage,
    sessionId,
    lastLocation,
    lrsGroup,
}) => {
    const [selectedActivities, setPartOfActivities] = useState([]);

    const lrsTrackingEventHandler = ({ id }) => {
        const locationObjectId = getLRSObjectForLocation(window.location);
        const extensions = {
            ...lrsTrackingInfo,
            [FROM_ROUTE_NAME]: `${window.location.origin}${lastLocation?.pathname}`,
            [INSTRUCTIONAL_ACTIVITY_ID]: id,
            [DOWNLOAD_LOCATION]: 'activity-list',
        };
        if (studentId) {
            extensions[ETERNAL_STUDENT_ID] = studentId;
        }
        if (lrsGroup) {
            extensions[GROUP_ID] = lrsGroup;
        }
        lrsEventOnAction(
            LRS_VERBS.DOWNLOADED,
            `${locationObjectId}-${LRS_EVENTS_XAPI_IDS.SPECIFIC_ACTIVITY}`,
            staffId,
            extensions,
            sessionId,
        );
    };

    const handlePageSelect = (pageActivities = []) => {
        setPartOfActivities(pageActivities);
    };

    return (
        <>
            <div className="bulk-activities-header" data-tour-step={ACTIVITIES_TITLE}>
                <TextCell content="Activities" classNames="title" isDataCell={false} />
                {children}
            </div>

            <ActivitiesSection
                activities={selectedActivities}
                onClickHandler={lrsTrackingEventHandler}
            />
            <Pagination
                items={activities}
                onSelect={handlePageSelect}
                onLrsSelect={selectPage}
                lrsGroup={lrsGroup}
            />
        </>
    );
};

ActivitiesWithPagination.defaultProps = {
    activities: [],
    staffId: null,
    studentId: '',
    lrsTrackingInfo: {},
    children: <></>,
    selectPage: () => {},
    sessionId: '',
    lastLocation: {},
    lrsGroup: '',
};

ActivitiesWithPagination.propTypes = {
    activities: PropTypes.array,
    staffId: PropTypes.string,
    studentId: PropTypes.string,
    lrsTrackingInfo: PropTypes.object,
    children: PropTypes.element,
    selectPage: PropTypes.func,
    sessionId: PropTypes.string,
    lastLocation: PropTypes.object,
    lrsGroup: PropTypes.string,
};

export default ActivitiesWithPagination;
